<div class="tab-navigation">
	<nav aria-label="Tabs" class="-mb-px flex space-x-4 rtl:space-x-reverse bg-transparent">
		@for (category of categories(); track category) {
			@let isActiveCategory$ = uiStore.isActiveCategorySignalFactory(category);
			<button
				type="button"
				(click)="onSelectCategory(category)"
				[class.active-category]="isActiveCategory$()"
				[class.hover:text-gray-700]="!isActiveCategory$()"
				[class.hover:border-gray-300]="!isActiveCategory$()"
				class="tab-button"
				[class.active]="category === activeCategory()"
			>
				<icon [icon]="categoryDisplayMap[category].icon" class="ml-1 mr-1.5 tab-icon" />
				{{ categoryDisplayMap[category].label | translate }}
			</button>
		} @empty {
			<p class="text-gray-500 italic">לא הוגדרו קטגוריות חיפוש.</p>
		}
	</nav>
</div>
